import React from "react";

/**
 * Lightweight inline markdown renderer:
 *   **bold**         → <strong>
 *   *italic*         → <em>
 *   [text](url)      → <a>
 *   ---              → <hr>
 *   line break       → <br>
 *   double newline   → paragraph break
 */
function renderInline(text, keyPrefix = "k") {
  if (!text) return null;
  const parts = [];
  let i = 0;
  let key = 0;
  const regex = /(\*\*([^*]+)\*\*|\*([^*]+)\*|\[([^\]]+)\]\(([^)]+)\))/g;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > i) parts.push(text.slice(i, m.index));
    if (m[2]) parts.push(<strong key={`${keyPrefix}-${key++}`}>{m[2]}</strong>);
    else if (m[3]) parts.push(<em key={`${keyPrefix}-${key++}`}>{m[3]}</em>);
    else if (m[4])
      parts.push(
        <a
          key={`${keyPrefix}-${key++}`}
          href={m[5]}
          target={/^https?:/.test(m[5]) ? "_blank" : undefined}
          rel={/^https?:/.test(m[5]) ? "noreferrer" : undefined}
          className="underline hover:text-[color:var(--tr-accent)]"
        >
          {m[4]}
        </a>
      );
    i = m.index + m[0].length;
  }
  if (i < text.length) parts.push(text.slice(i));
  return parts;
}

export default function RichText({ value, className, as: As = "p", style }) {
  if (!value) return null;
  // Split paragraphs by double newline
  const paragraphs = String(value).split(/\n{2,}/);
  return (
    <>
      {paragraphs.map((para, idx) => {
        if (para.trim() === "---") {
          return <hr key={idx} className="my-6 border-[color:var(--tr-border)]" />;
        }
        // single newlines → <br>
        const lines = para.split(/\n/);
        return (
          <As key={idx} className={className} style={style}>
            {lines.map((line, li) => (
              <React.Fragment key={li}>
                {renderInline(line, `p${idx}-l${li}`)}
                {li < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </As>
        );
      })}
    </>
  );
}
